import React from 'react';
import styled from 'styled-components';

import PlanBenefits from './PlanBenefits';
import BenefitDetails from './BenefitDetails';
import PlanSummaryDetails from './PlanSummaryDetails';
import CoveredMemberDetails from './CoveredMemberDetails';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import ActionButtonContainer from './ActionButtonContainer';
import { IEnrollmentDetails } from './enrollmentHistoryTypes';
import { PLAN_TYPE } from '../../../modules/custom-grouping/modals/modalTypes';
import { useStateCode } from '../../../hooks';

const StyledContainer = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.gray11};
    border-right: 1px solid ${({ theme }) => theme.gray11};
    border-left: 1px solid ${({ theme }) => theme.gray11};
    padding: 20px 5px 10px 5px;
    .plan-benefit{
        padding:30px 10px 0 10px;
    }

    .grid-header{
        text-transform: uppercase;
        display:flex;
        padding:6px;
        padding-left:12px;
    }
    .header-border{
        border-bottom:1px solid ${({ theme }) => theme.gray8};
        margin-bottom:1em;
    }
  
    .grid-body{
        div{
            display: flex;
        }
        span{
            padding:6px;
            flex: 1 1 0;
            font-weight: normal;
            color:${({ theme }) => theme.gray3};
            padding-left:12px;
            font-size:${({ theme }) => theme['font-size-inbox-table']};
        }
        .tooltip-container{
            span{
                padding:0px;
            }
        }
    }
`;

const StyledRow = styled.div`
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
`;

const EnrollmentContainer = (props: { enrollments: IEnrollmentDetails[], activeEnrollment: string, coverageStartDateForDisenrollment: string, coverageYear: string }) => {
    const { enrollments, activeEnrollment, coverageStartDateForDisenrollment, coverageYear } = { ...props };
    const { isEnrollmentBorderVisible } = useStateCode();

    const isFirstActiveHealthEnrollment = (index: number, planType: string): boolean => {
        return (
            activeEnrollment.toUpperCase() === 'TRUE' &&
            index === 0 &&
            planType.toUpperCase() === PLAN_TYPE.HEALTH
        );
    };

    return (
        <>
            {enrollments.map((enrollment, index) => (
                <StyledContainer data-testid={`${activeEnrollment==='true'?'active-':'past-'}${enrollment.planType}-${index}`} key={enrollment.enrollmentId} className={ isEnrollmentBorderVisible ? 'enrollment-with-border' : '' }>
                    <div className={isFirstActiveHealthEnrollment(index, enrollment.planType) ? 'first-active-health' : ''}>
                        <StyledRow className="row plan-benefit">
                            <PlanBenefits enrollmentDetails={enrollment} />
                            <BenefitDetails enrollmentDetails={enrollment} />
                        </StyledRow>
                        <StyledRow className="row margin-0">
                            <PlanSummaryDetails enrollmentDetails={enrollment} />
                            <CoveredMemberDetails enrollmentDetails={enrollment} />
                        </StyledRow>
                        <ConditionalRendering isTrue={activeEnrollment.toUpperCase() === 'TRUE'}>
                            <ActionButtonContainer enrollmentDetails={enrollment} coverageStartDateForDisenrollment={coverageStartDateForDisenrollment} coverageYear={coverageYear}/>
                        </ConditionalRendering>
                    </div>
                </StyledContainer>
            ))}
        </>
    );
};

export default EnrollmentContainer;